export default __webpack_public_path__ + "static/media/blue-curve.dbf864a9.svg";